import React from "react";
import { skills } from "../../portfolio";
import { Fade } from "react-reveal";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import AIMLGenAIImg from "./AIMLGenAIImg";
import FullStackImg from "./FullStackImg";
import CloudInfraImg from "./CloudInfraImg";
import { useLanguage } from "../../context/LanguageContext";
import translations from "../../i18n/translations";
import "./Skills.css";

function GetSkillSvg(props) {
  if (props.fileName === "AIMLGenAIImg")
    return <AIMLGenAIImg theme={props.theme} />;
  if (props.fileName === "FullStackImg")
    return <FullStackImg theme={props.theme} />;
  if (props.fileName === "CloudInfraImg")
    return <CloudInfraImg theme={props.theme} />;
  return null;
}

function SkillSection(props) {
  const theme = props.theme;
  const { lang } = useLanguage();
  const tCategories = translations[lang].skills.categories;

  return (
    <div>
      {skills.data.map((skill, index) => {
        const tCat = tCategories[index] || {};
        const title = tCat.title || skill.title;
        const sentences = tCat.skills || skill.skills;

        if (index % 2 === 0) {
          return (
            <div key={"skills-" + index} className="skills-main-div">
              <Fade left duration={2000}>
                <div className="skills-image-div">
                  <GetSkillSvg fileName={skill.fileName} theme={theme} />
                </div>
              </Fade>
              <div className="skills-text-div">
                <Fade right duration={1000}>
                  <h1 className="skills-heading" style={{ color: theme.text }}>
                    {title}
                  </h1>
                </Fade>
                <Fade right duration={1500}>
                  <SoftwareSkill theme={theme} logos={skill.softwareSkills} />
                </Fade>
                <Fade right duration={2000}>
                  <div className="skills-description">
                    {sentences.map((sentence, i) => (
                      <p
                        key={"skill-sentence-" + i}
                        className="subTitle skills-text"
                        style={{ color: theme.secondaryText }}
                      >
                        {sentence}
                      </p>
                    ))}
                  </div>
                </Fade>
              </div>
            </div>
          );
        } else {
          return (
            <div key={"skills-" + index} className="skills-main-div">
              <div className="skills-text-div">
                <Fade left duration={1000}>
                  <h1 className="skills-heading" style={{ color: theme.text }}>
                    {title}
                  </h1>
                </Fade>
                <Fade left duration={1500}>
                  <SoftwareSkill theme={theme} logos={skill.softwareSkills} />
                </Fade>
                <Fade left duration={2000}>
                  <div className="skills-description">
                    {sentences.map((sentence, i) => (
                      <p
                        key={"skill-sentence-" + i}
                        className="subTitle skills-text"
                        style={{ color: theme.secondaryText }}
                      >
                        {sentence}
                      </p>
                    ))}
                  </div>
                </Fade>
              </div>
              <Fade right duration={2000}>
                <div className="skills-image-div">
                  <GetSkillSvg fileName={skill.fileName} theme={theme} />
                </div>
              </Fade>
            </div>
          );
        }
      })}
    </div>
  );
}

export default SkillSection;
